import { useQuery, gql, useLazyQuery } from '@apollo/client';
import {
  ProfessorPageQuery,
  ProfessorPageQueryVariables,
} from './__generated__/ProfessorPageQuery';

const PROFESSOR_PAGE_QUERY = gql`
  query ProfessorPageQuery($id_professor: Int!, $dat_inicio: String, $dat_fim: String) {
    professor(id_professor: $id_professor) {
      id_professor
      dsc_nome_professor
      dsc_titulacao
      dsc_email
      dsc_email2
      dsc_email3
      dsc_num_telefone
      dsc_num_telefone2
    }

    alocacoes_professor(
      where: { id_professor: $id_professor, dat_inicio: $dat_inicio, dat_fim: $dat_fim }
    ) {
      dat_alocacao
      id_oferta
      id_turma
      ind_status
      planejamento
      turma {
        id_turma
        num_turma
      }
      oferta {
        id_oferta
        num_oferta
        curso {
          id_curso
          id_unidade
          dsc_nome_curso
        dsc_sigla_curso
        }
      }
      disciplina {
        id_disciplina
        dsc_nome_disciplina
        dsc_sigla
        num_carga_horaria
      }
      horario {
        hora_inicio
        hora_fim
      }
    }
  }
`;

const useProfessorPageQuery = (variables: ProfessorPageQueryVariables) => {
  return useQuery<ProfessorPageQuery, ProfessorPageQueryVariables>(PROFESSOR_PAGE_QUERY, {
    variables,
  });
};

const useProfessorPageLazyQuery = () => {
  return useLazyQuery<ProfessorPageQuery, ProfessorPageQueryVariables>(PROFESSOR_PAGE_QUERY);
};

export { useProfessorPageQuery, useProfessorPageLazyQuery };
